/**
 * VAS — Escala Visual Analógica de dor (0-10).
 * Visualização premium: gradient verde→amarelo→vermelho com bolha glow.
 */
export default function VasScale({ value = 0, onChange, readOnly = false, compact = false }) {
  const v = Math.max(0, Math.min(10, value || 0));
  const pct = (v / 10) * 100;
  const color = v <= 3 ? "#34d399" : v <= 6 ? "#fbbf24" : "#f43f5e";
  const glow  = v <= 3 ? "rgba(52,211,153,0.55)" : v <= 6 ? "rgba(251,191,36,0.55)" : "rgba(244,63,94,0.6)";
  const label = v === 0 ? "Sem dor" : v <= 3 ? "Dor ligeira" : v <= 6 ? "Dor moderada" : v <= 8 ? "Dor intensa" : "Dor máxima";

  return (
    <div className="rounded-2xl border border-slate-800 bg-slate-900/40 p-5" data-testid="vas-scale">
      <div className="flex items-end justify-between">
        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-sky-400 font-semibold">Escala de Dor (VAS)</div>
          {!compact && <p className="text-[11px] text-slate-500 mt-1">Pede ao paciente para indicar o nível de dor de 0 (sem dor) a 10 (dor máxima).</p>}
        </div>
        <div className="text-right">
          <div className="font-display text-4xl" style={{ color, textShadow: `0 0 16px ${glow}` }}>{v}</div>
          <div className="text-[11px]" style={{ color }}>{label}</div>
        </div>
      </div>

      <div className="relative h-3 mt-5 rounded-full overflow-hidden bg-slate-800">
        <div className="absolute inset-0" style={{
          background: "linear-gradient(90deg, #34d399 0%, #fbbf24 50%, #f43f5e 100%)",
          opacity: 0.35,
        }} />
        <div className="absolute inset-y-0 left-0 rounded-full"
             style={{ width: `${pct}%`, background: color, boxShadow: `0 0 12px ${glow}` }} />
        <div className="absolute -top-1.5 w-4 h-4 rounded-full border-2 border-white/80"
             style={{
               left: `calc(${pct}% - 8px)`,
               background: color,
               boxShadow: `0 0 10px ${glow}`,
               transition: "left .2s ease",
             }} />
      </div>

      {!readOnly && (
        <input
          data-testid="vas-input"
          type="range" min={0} max={10} step={1}
          value={v}
          onChange={(e) => onChange?.(parseInt(e.target.value, 10))}
          className="w-full mt-3 accent-sky-400"
        />
      )}

      <div className="flex justify-between text-[10px] text-slate-500 font-mono mt-1 px-1">
        {[0,2,4,6,8,10].map(n => <span key={n}>{n}</span>)}
      </div>
    </div>
  );
}
